/**
 * Command runner waves barrel (docs/architecture/command-parity-plan.md).
 * Each wave module exports a RunnerMap; this barrel registers them all into
 * the shared runner registry at boot (CommandRegistrar calls registerWaveRunners).
 */

import { registerCommandActions } from '../runnerRegistry';
import { queryRunners } from './queryCommands';
import { drawRunners } from './drawCommands';
import { sysvarRunners } from './sysvarCommands';
import { viewRunners } from './viewCommands';
import { selectRunners } from './selectCommands';
import { solidRunners } from './solidCommands';
import { meshRunners } from './meshCommands';
import { dimRunners } from './dimCommands';
import { deformRunners } from './deformCommands';
import { blockRunners } from './blockCommands';
import { surfaceRunners } from './surfaceCommands';
import { subdRunners } from './subdCommands';
import { analysisRunners } from './analysisCommands';
import { sheetRunners } from './sheetCommands';
import { fileRunners } from './fileCommands';
import { modRunners } from './modCommands';
import { transformRunners } from './transformCommands';
import { cadDraftRunners } from './cadDraftCommands';
import { layoutRunners } from './cadLayoutCommands';
import { plotRunners } from './plotCommands';
import { constraintRunners } from './constraintCommands';
import { constraintDimRunners } from './constraintDimCommands';
import { draftLongtailRunners } from './draftLongtailCommands';
import { mvsetupRunners } from './mvsetupCommands';

const ALL_WAVES = {
    ...queryRunners,
    ...drawRunners,
    ...sysvarRunners,
    ...viewRunners,
    ...selectRunners,
    ...solidRunners,
    ...meshRunners,
    ...dimRunners,
    ...deformRunners,
    ...blockRunners,
    ...surfaceRunners,
    ...subdRunners,
    ...analysisRunners,
    ...sheetRunners,
    ...fileRunners,
    ...modRunners,
    ...transformRunners,
    // CAD-viewport parity wave (Faz 0): registered last so its full-featured
    // hatch/hatchedit runners supersede the earlier approximation versions.
    ...cadDraftRunners,
    // CAD paper space (Faz 9 option A): layout ids override the BIM sheet
    // bridge for the 2D workspace commands.
    ...layoutRunners,
    // Real plot pipeline (Faz 2): PLOT / PAGESETUP / PUBLISH override the
    // sheet bridge with the vector PDF dialog flow — registered last.
    ...plotRunners,
    // Parametric constraint layer (Faz 6): geometric + dimensional
    // constraint commands registered last so they win the id pool.
    ...constraintRunners,
    ...constraintDimRunners,
    // Drafting long tail (Faz 7): DIVIDE/MEASURE, TRACE, REVERSE, OVERKILL —
    // new ids only, no collisions with the waves above.
    ...draftLongtailRunners,
    // MVSETUP (Faz 10.4): new id only, layout/view surfaces untouched.
    ...mvsetupRunners,
};

let registered = false;

export function registerWaveRunners(): void {
    if (registered) return;
    registered = true;
    registerCommandActions(ALL_WAVES);
}

export { ALL_WAVES };
